export default __webpack_public_path__ + "static/media/rock.2a0b5ee1.svg";